import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard.scss";
import 'assets/css/bevan.css';

import AuthLayout from "layouts/Auth.js";
import ChatLayout from "layouts/Chat.js";
import MainLayout from "layouts/Main.js";

import { ChatProvider } from "contexts/ChatContext";
import SettingsProvider from "contexts/SettingsContext";
import { SidebarProvider } from "contexts/SidebarContext";
import { AuthProvider } from "contexts/AuthContext";
import ProtectedRoute from "components/Auth/ProtectedRoute";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <SettingsProvider>
        <SidebarProvider>
          <ChatProvider>
            <Routes>
              <Route path="/auth/*" element={<AuthLayout />} />
              <Route path="/c/*" element={<ProtectedRoute><ChatLayout /></ProtectedRoute>} />
              <Route path="/*" element={<MainLayout />} />
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </ChatProvider>
        </SidebarProvider>
      </SettingsProvider>
    </AuthProvider>
  </BrowserRouter>
);
